import { checkDateValidity, getUSFormatDate } from 'utils';
import actionTypes from '../actions/actionTypes';

export const INITIAL_STATE = {
  loading: false,
  error: false,
  data: {
    emailsCount: 0,
    looksCount: 0,
    productsCount: 0,
    shoppingBagsCount: 0,
    appointmentsCount: 0,
    validThrough: '',
  },
};

const associateEngagementsReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case actionTypes.ASSOCIATE_ENGAGEMENTS_LOADING:
      return {
        ...state,
        loading: true,
      };
    case actionTypes.ASSOCIATE_ENGAGEMENTS_SUCCESS:
      return {
        ...state,
        loading: false,
        data: {
          emailsCount: payload.emailsCount,
          looksCount: payload.looksCount,
          productsCount: payload.productsCount,
          shoppingBagsCount: payload.shoppingBagsCount || 0,
          appointmentsCount: payload.appointmentsCount || 0,
          validThrough: checkDateValidity(payload.validThrough) ? getUSFormatDate(payload.validThrough) : '',
        },
      };
    case actionTypes.ASSOCIATE_ENGAGEMENTS_ERROR:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    default:
      return state;
  }
};

export default associateEngagementsReducer;
